import React from "react";

const Heart = ({ style, stylePath }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_568" transform="translate(-1415 -391)">
        <path
          style={stylePath}
          id="Tracciato_127"
          d="M26.069,5.047a6.991,6.991,0,0,0-9.886,0l0,0L14.833,6.394,13.485,5.047A6.992,6.992,0,0,0,3.6,14.936l1.347,1.347,9.889,9.889,9.889-9.889,1.347-1.347a6.991,6.991,0,0,0,0-9.886Z"
          transform="translate(1415.951 392.502)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Heart;
